import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const NAV = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Kind Words", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export const Header = ({ calendlyUrl }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-md border-b border-blush-200/50"
          : "bg-transparent"
      }`}
    >
      <div className="sc-container flex items-center justify-between h-[76px] md:h-[88px]">
        <a href="#top" className="shrink-0" data-testid="header-logo-link" aria-label="See Chelle home">
          <Logo size="sm" />
        </a>

        <nav className="hidden md:flex items-center gap-9" aria-label="Primary">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-[13px] tracking-[0.18em] uppercase text-ink/80 hover:text-magenta transition-colors font-body"
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={calendlyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:inline-flex sc-btn-primary !py-2.5 !px-5 !text-[13px]"
            data-testid="header-book-chat-btn"
          >
            Book a 20 min chat
          </a>
          <button
            type="button"
            className="md:hidden p-2 -mr-2 text-ink"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="md:hidden bg-white border-t border-blush-200/60" data-testid="mobile-menu">
          <div className="sc-container py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-base tracking-wide text-ink/90 hover:text-magenta font-body"
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {n.label}
              </a>
            ))}
            <a
              href={calendlyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="sc-btn-primary mt-2 self-start"
              onClick={() => setOpen(false)}
              data-testid="mobile-book-chat-btn"
            >
              Book a 20 min chat
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
